import { lazy, Suspense } from 'react';
import { Route, Switch } from 'wouter';
import { SessionGate } from './auth/SessionGate.tsx';
import { StatusMessage } from './components/StatusMessage.tsx';
import { ForgotPage } from './pages/ForgotPage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { ResetPage } from './pages/ResetPage.tsx';

// The login page is the only thing an anonymous visitor ever loads, so the
// rest of the app lives in its own chunk that is fetched only once the
// session gate has confirmed a signed-in user.
const AuthenticatedApp = lazy(async () => {
  const module = await import('./authenticated/AuthenticatedApp.tsx');
  return { default: module.AuthenticatedApp };
});

export function AppRoutes() {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/forgot" component={ForgotPage} />
      <Route path="/reset" component={ResetPage} />
      <Route>
        <SessionGate>
          <Suspense fallback={<StatusMessage>Loading…</StatusMessage>}>
            <AuthenticatedApp />
          </Suspense>
        </SessionGate>
      </Route>
    </Switch>
  );
}
